import { render, staticRenderFns } from "./Fodder.vue?vue&type=template&id=130376a2&scoped=true&"
import script from "./Fodder.vue?vue&type=script&lang=js&"
export * from "./Fodder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130376a2",
  null
  
)

export default component.exports